import { useState } from 'react';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import {insertURLParameter} from '@Components/Utilities/SandhillsUtility';


const PartsSearch = (props) => {

    const [keyword, setKeyword] = useState(props.keyword ?? '');
    const [searchType, setSearchType] = useState('Start');

    const submitForm = (e) => {
        e.preventDefault();
        let keywordKey = props.shouldShowPartNumberSearch ? 'PartNumber' : 'Keywords';
        let url = keyword ? props.searchURL : props.partsLandingURL;
        if (keyword) {
            url = insertURLParameter(url, keywordKey, keyword);
            if (props.shouldShowPartNumberSearch) {
                url = insertURLParameter(url, 'SearchType', searchType);
            }
        }
       
        window.location.href = url;
    };

    const onInputChange = (e) => {
        setKeyword(e.target.value);
        if (props.shouldShowPartNumberSearch && props.setPartNumber) {
            props.setPartNumber(e.target.value);
        }
        else if (props.setKeyword) {
            props.setKeywords(e.target.value);
        }
    };

    const onSearchTypeChange = (type) => {
        setSearchType(type);
    };

    return (
        <div className={props.outerDivClass ?? ''}>
            <form className={props.formClass ?? ''} onSubmit={submitForm}>
                <div className={props.innerDivClass ?? ''}>
                    {props.includeLabel &&
                        <label htmlFor='part-search' className='part-label'>
                            <TranslationText tKey='sandhills.searchforparts' />
                        </label>}
                    <input className={props.partsSearchInputClass ?? ''} id={!props.includeLabel ? props.inputId : 'part-search'} value={keyword} onChange={onInputChange} type='text' name='partNumber' placeholder={props.placeholder} />
                    <input className={props.partsSearchButtonClass ?? ''} type='submit' value={translator.translate('sandhills.tradepubwebsite.mvc.search')} />
                </div>
                {props.shouldShowPartNumberSearch &&
                    <div className='parts-radio'>
                        <fieldset className='ts__fieldset'>
                            <legend className='visually-hidden ts__legend'>{translator.translate('sandhills.selectasearchtype')}</legend>
                            <div className='search-type'>
                                <label>
                                    <input type='radio' name='SearchType' value='Start' onChange={(e) => { onSearchTypeChange('Start'); }} checked={searchType !== 'Exact'} />
                                    <TranslationText tKey='sandhills.startswith' />
                                </label>
                            </div>
                            <div className='search-type'>
                                <label>
                                    <input type='radio' name='SearchType' value='Exact' onChange={(e) => { onSearchTypeChange('Exact');}} checked={searchType === 'Exact'} />
                                    <TranslationText tKey='Sandhills.TradePubWebSite.MVC.ExactMatch' />
                                </label>
                            </div>
                        </fieldset>
                    </div>
                }
            </form>
            {props.showNoPartNumberLink &&
                <div className='parts-link'>
                    <TranslationText tKey='Sandhills.TradeSites.MVC.NoPartNumberQuestion' /> &nbsp; <a href={props.partsLandingURL}><TranslationText tKey='Sandhills.TradeSites.MVC.ViewByCategoryOrManufacturer' /> </a>
                </div>}
        </div>
    );
};

export default PartsSearch;